module.exports = __webpack_public_path__ + "images/login-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login-bg.jpg
// module id = 931
// module chunks = 0 1 2 3 4 5